import { Icon, IconOptions } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { ModBox } from '../ModifiedBox/ModifiedBox'

export const BackComp = ({ onPress }: any) => {
  const navigation = useNavigation()
  onPress =
    onPress ||
    (() => {
      navigation.goBack()
    })
  return iconButton(onPress)
}

const iconButton = (onPress: any) => {
  return (
    <ModBox pl={10} underlayColor="WHITE" testID="arrow-back" onPress={onPress}>
      <Icon id={'ARROW_BACK' as IconOptions} color="BLUE" size={22} />
    </ModBox>
  )
}
